var English = "English";
var French = "French";
var German = "German";
var Italian = "Italian";
var Japanese = "Japanese";
var Korean = "Korean";
var Portuguese = "Portuguese";
var Russian = "Russian";
var Spanish = "Spanish";
var Bahasa = "Bahasa";
var Thai = "Thai";
var Vietnamese = "Vietnamese";
var Turkish = "Turkish";
var Arabic = "Arabic";
var languagePreference = {
	English: English,
	French: French,
	German: German,
	Italian: Italian,
	Japanese: Japanese,
	Korean: Korean,
	Portuguese: Portuguese,
	Russian: Russian,
	"Chinese-Simplified": "Chinese-Simplified",
	"Chinese-Traditional": "Chinese-Traditional",
	Spanish: Spanish,
	Bahasa: Bahasa,
	Thai: Thai,
	Vietnamese: Vietnamese,
	Turkish: Turkish,
	Arabic: Arabic
};

export { Arabic, Bahasa, English, French, German, Italian, Japanese, Korean, Portuguese, Russian, Spanish, Thai, Turkish, Vietnamese, languagePreference as default };
